import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { axiosPublic } from 'app/utils';

import type { Invite } from '../types';

export const INVITE_QUERY_KEY = 'invite';

async function fetchInvite(inviteId: string): Promise<Invite> {
  const response = await axiosPublic.get<Invite>(`/v3/invites/${encodeURIComponent(inviteId)}`);

  return response.data;
}

// The page renders its own not-found state, so the global error toast is silenced.
export default function useInvite(inviteId: string | undefined): UseQueryResult<Invite> {
  return useQuery<Invite>({
    queryKey: [INVITE_QUERY_KEY, inviteId],
    queryFn: () => {
      if (!inviteId) throw new Error('Missing invite id');
      return fetchInvite(inviteId);
    },
    enabled: Boolean(inviteId),
    retry: false,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    meta: { silenceErrors: true },
  });
}
